export default {
  web: {
    common: {
      for: "para",
      today: "Hoje",
      unknown: "Desconhecido",
      checkout: "Finalizar compra",
      noOdds: "Sem odds",
    },
    navigation: {
      tools: "Ferramentas",
      getLinematePlus: "Obter Linemate+",
      startFreeTrial: "Começar teste grátis",
      downloadLinemate: "Baixar Linemate",
      profileSettings: "Ajustes do perfil",
      closeMyPicks: "Fechar Minhas escolhas",
      offSeason: "{{league}} está na entressafra. Até a próxima temporada.",
      search: {
        teams: "Equipes",
        noResultsFor: "Nenhum resultado encontrado para \"{{searchTerm}}\"",
      },
      toolsMenu: {
        opponentDefensiveRank: "Ranking defensivo do adversário",
        startingOpponentPitchers: "Arremessadores titulares adversários",
      },
    },
    toastModal: {
      title: "O que há de novo?",
      items: {
        checkout: "Finalize no seu book preferido com Minhas escolhas.",
        preferredOdds: "Veja odds de tendências com suas odds preferidas (disponível para usuários Linemate+).",
      },
      actions: {
        dismiss: "Fechar",
      },
    },
    carousel: {
      previous: "Anterior",
      next: "Próximo",
    },
  },
};
